export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getAllProducts() {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/product/all")
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        getPaginatedProducts(_, page) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/product/index?page=" + page)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        deleteProduct(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/product/delete/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        toggleProductStatus(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/product/toggle-status/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        createProduct(_, data) {
            let formData = new FormData();
            Object.keys(data).forEach(key => {
                if (data[key].constructor === Array) {
                    data[key].forEach((value, key2) => {
                        console.log(value)
                        formData.append(key + '[' + key2 + ']' + '[order]', value.order)
                        formData.append(key + '[' + key2 + ']' + '[en_value]', value.en_value)
                        formData.append(key + '[' + key2 + ']' + '[fa_value]', value.fa_value)
                        formData.append(key + '[' + key2 + ']' + '[specification_id]', value.specification_id)
                    })

                } else if (data[key]) {
                    formData.append(key, data[key])
                }
            });
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/product/store", formData)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateProduct(_, payload) {
            let formData = new FormData();
            Object.keys(payload.data).forEach(key => {
                if (payload.data[key] && payload.data[key].constructor === Array) {
                    payload.data[key].forEach((value, key2) => {
                        if (value.order) {
                            formData.append(key + '[' + key2 + ']' + '[order]', value.order)
                        }
                        if (value.en_value) {
                            formData.append(key + '[' + key2 + ']' + '[en_value]', value.en_value)
                        }
                        if (value.fa_value) {
                            formData.append(key + '[' + key2 + ']' + '[fa_value]', value.fa_value)
                        }
                        if (value.specification_id && (value.en_value || value.fa_value)) {
                            formData.append(key + '[' + key2 + ']' + '[specification_id]', value.specification_id)
                        }
                    })

                } else if (payload.data[key]) {
                    formData.append(key, payload.data[key])
                }
            });
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/product/update/" + payload.identifier, formData)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        singleProduct(_, identifier) {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/product/show/" + identifier)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
    },
}

